export const SET_MODAL_OPEN = 'feature/reportListing/SET_MODAL_OPEN';
export const SET_MODAL_CLOSE = 'feature/reportListing/SET_MODAL_CLOSE';
export const SET_REPORTED_LISTING =
  'feature/reportListing/SET_REPORTED_LISTING';
export const SET_REPORTED_LISTINGS =
  'feature/reportListing/SET_REPORTED_LISTINGS';
